import React from "react";
import { FormControl, TextField, FormControlLabel, Radio, RadioGroup, FormLabel  } from '@mui/material';
import muiInputStyles from "../../../uiComponents/MuiInput/MuiInputStyles";
import Format from "../../../utils/Format";
import HGVSNames from "../../HGVSNames";
const ClassificationForm = ({
  summaryExists,
  summary,
  programClassification,
  comments,
  handleOptionChange,
  setComments,
  BENIGN,
  LIKELY_BENIGN,
  UNCERTAIN_SIGNIFICANCE,
  LIKELY_PATHOGENIC,
  PATHOGENIC
}) => {

  const classes = muiInputStyles();

  return (
    <>
      <div className="classificationFormItem summaryFieldsContainer">
        <div>
          <div className="muiFormItem">
            Gene: {summaryExists ? <b className="gene">{Format.CommaSeparatedList(summary.gene)}</b> : 'loading'}
          </div>
          <div className="muiFormItem">
            Potential Condition: {summaryExists ? <b>{summary.condition}</b> : 'loading'}
          </div>
          <div className="muiFormItem" style={{ display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ marginRight: '8px' }}>HGVS Names:</span> {summaryExists ? <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'inline-block', maxWidth: '100%' }}><HGVSNames variantId={summary.variantId} bold={true} /> </div> : 'loading'}
          </div>
        </div>
      </div>

      <div className="classificationFormItem muiFormItem">
        <span className="requiredIndicator">*</span> Indicates a required field.
      </div>

      <div className="classificationFormItem muiFormItem">
        <FormControl component="fieldset" className={classes.muiInputs}>
          <FormLabel className={classes.muiInputs} required={true} component="legend">Classification</FormLabel>
          <RadioGroup className={classes.muiInputs} aria-label="classification" name="classification" onChange={handleOptionChange}>
            <FormControlLabel 
              value={BENIGN} 
              id={BENIGN} 
              checked={programClassification === BENIGN} 
              control={<Radio 
                        inputProps={{
                          "aria-required": true // required attr for screen readers
                        }} 
                      />} 
              label={BENIGN} 
            />
            <FormControlLabel 
              value={LIKELY_BENIGN} 
              id={LIKELY_BENIGN} 
              checked={programClassification === LIKELY_BENIGN} 
              control={<Radio  
                        inputProps={{
                          "aria-required": true // required attr for screen readers
                        }} 
                      />} 
              label={LIKELY_BENIGN} 
            />
            <FormControlLabel 
              value={UNCERTAIN_SIGNIFICANCE} 
              id={UNCERTAIN_SIGNIFICANCE} 
              checked={programClassification === UNCERTAIN_SIGNIFICANCE} 
              control={<Radio  
                        inputProps={{
                          "aria-required": true // required attr for screen readers
                        }} 
                      />} 
              label={UNCERTAIN_SIGNIFICANCE} 
            />
            <FormControlLabel 
              value={LIKELY_PATHOGENIC} 
              id={LIKELY_PATHOGENIC} 
              checked={programClassification === LIKELY_PATHOGENIC} 
              control={<Radio 
                        inputProps={{
                          "aria-required": true // required attr for screen readers
                        }} 
                      />} 
              label={LIKELY_PATHOGENIC} 
            />
            <FormControlLabel 
              value={PATHOGENIC} 
              id={PATHOGENIC} 
              checked={programClassification === PATHOGENIC} 
              control={<Radio 
                        inputProps={{
                          "aria-required": true // required attr for screen readers
                        }} 
                      />} 
              label={PATHOGENIC} 
            />
          </RadioGroup>
        </FormControl>
      </div>
      <div className="classificationFormItem">
        <FormControl fullWidth>
          <TextField
            fullWidth
            size="small"
            id="interpretationComments"
            name="comment"
            className={classes.muiInputs}
            value={comments || ''}
            onChange={(event) => setComments(event.target.value)}
            variant="outlined"
            label="Comments"
            multiline
            minRows={6}
            inputProps={{ 
              maxLength: 1000,
              "aria-required": true, // required attr for screen readers
            }}
            required
          />
        </FormControl>
      </div>
    </>
  );
};

export default ClassificationForm;